import { render, staticRenderFns } from "./AluZaun.vue?vue&type=template&id=4fba8a86&"
import script from "./AluZaun.vue?vue&type=script&lang=js&"
export * from "./AluZaun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports